'use client';

import { cn } from '@noirproperties/ui/lib/utils';
import { useVideoState } from './video-hooks';

type VideoOverlayProps = {
  slots: {
    visible: React.ReactNode;
    hidden: React.ReactNode;
  };
  children?: React.ReactNode;
};

export function VideoOverlay({ slots, children }: VideoOverlayProps) {
  const { isPlaying } = useVideoState();

  return (
    <section
      className={cn(
        `relative isolate h-svh w-full overflow-hidden pt-48 before:absolute before:inset-0 before:z-20 before:h-80 before:w-full before:bg-gradient-to-b before:from-neutral-900/50 ${
          !isPlaying
            ? 'after:absolute after:inset-0 after:-z-10 after:h-screen after:w-full after:bg-neutral-950 after:opacity-55 lg:after:w-2/3 lg:after:opacity-60 lg:after:[clip-path:polygon(0%_0%,_100%_0%,90%_100%,_0%_100%)] lg:after:rtl:[clip-path:polygon(0%_0%,_100%_0%,_100%_100%,_10%_100%)]'
            : ''
        } sm:pt-48 lg:pt-56`,
      )}
      id="video"
    >
      <div className="z-30 mx-auto max-w-7xl">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
          {!isPlaying ? slots.visible : slots.hidden}

          {children}
        </div>
      </div>
    </section>
  );
}
